import { UiToast } from 'components';

const getString = (str) => {
  let getStr = {};

  if (str.indexOf('#') > -1) {
    getStr = {
      name: str.split('#')[1],
      val: str.split('#')[2],
    };
  } else {
    getStr = {
      name: '',
      val: str,
    };
  }

  return getStr;
};

const handle = (socket) => {
  // 模版消息推送
  socket.on('template.message', (data, {}, { messages, marquee }) => {
    const isSuper = !!data.style;
    const isMessage = !data.type;

    let actionName = '';
    let url = '';
    let room_id = '';

    if (data.href) {
      const mRootUrl = MM.core.getRoot('', 'm');
      const isAndroidLinkOnly = data.href.indexOf('#android-dl#') > -1;
      const isActions = data.href.indexOf(mRootUrl) > -1;

      if (!isAndroidLinkOnly) {
        if (isActions) {
          const pcRootUrl = MM.core.getRoot('', 'main');
          const str = getString(data.href).val;
          url = str.replace(mRootUrl, pcRootUrl);
        } else {
          room_id = getString(data.href).val;
        }
      } else if (data.href.indexOf('memeFish')) {
        actionName = 'showBuYuGame';
      }
    }

    // 超级跑道
    if (isSuper) {
      marquee.pushSuperItem('TplMarquee', {
        ...data,
        room_id,
        url,
      });
    }

    // 聊天信息流
    if (isMessage) {
      messages.add({
        msg: data,
        msgType: 'tplMsg',
      });
    } else {
      // 普通跑道
      marquee.pushMarqueeItem('TplMarquee', {
        ...data,
        actionName,
        room_id,
        url,
      });
    }
  });

  socket.on('flowing', (msg) => {
    UiToast.text(msg.data.text);
  });
};

export default handle;
